import classNames from "classnames";
import { ChipTemplate } from "../Template";
import styles from "./Chip.module.scss";
import React from "react";
function Chip({ size, styleType, className, classNameContent, classNamesStateLayer, iconOnly, ...props }) {
    return (React.createElement(ChipTemplate, { className: classNames(styles.chip, styles[size], styles[styleType], iconOnly && styles["icon-only"], className), classNameContent: classNames(styles.content, classNameContent), classNamesStateLayer: classNames(styles["state-layer"], classNamesStateLayer), ...props }));
}
export default Chip;
